/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Support_DescriptionInputs */

const en_wb_support_description = /** @type {(inputs: Wb_Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing is sent until you’ve checked the reply.`)
};

const lv_wb_support_description = /** @type {(inputs: Wb_Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nekas netiek nosūtīts, kamēr neesat pārbaudījis atbildi.`)
};

/**
* | output |
* | --- |
* | "Nothing is sent until you’ve checked the reply." |
*
* @param {Wb_Support_DescriptionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_support_description = /** @type {((inputs?: Wb_Support_DescriptionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Support_DescriptionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_support_description(inputs)
	return en_wb_support_description(inputs)
});